<template><div><h1 id="ereignispositionen" tabindex="-1"><a class="header-anchor" href="#ereignispositionen"><span>Ereignispositionen</span></a></h1>
<p>Ereignispositionen — Detaillierte Uebersicht der definierten Ereignispositionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Unter Ereignispositionen werden die detaillierten Angaben zu den vorgängig definierten Ereignispositionen angezeigt.</p>
<p>Pfad: <code v-pre>Personen → Ereignisse</code></p>
<h2 id="datenfelder-der-ereignispositionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-der-ereignispositionen"><span>Datenfelder der Ereignispositionen</span></a></h2>
<dl>
<dt>Ereignis</dt>
<dd>Ereignisnummer</dd>
<dt>Pos.</dt>
<dd>Ereignispositionsnummer. Die Länge wird validiert. Bei Spendenereignissen darf z.B. wegen der ESR-Nummer die Ereignisnummer nur maximal 2-stellig sein.</dd>
<dt>Kostentr.</dt>
<dd>Kostenträger</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Ereignisposition. Es empfiehlt sich aus Gründen der Übersichtlichkeit, die gleicqhen Bezeichnungen zu verwenden wie in den Filtern.</dd>
<dt>Fremd-DB</dt>
<dd>Fremd-Datenbank-Nummer: bei Fremdadressen muss hier die Kennzeichnung der Fremddatenbank hinterlegt werden. Pro Ereignisposition können entweder Fremd- oder Eigenadressen verknüpft werden</dd>
<dt>Initial</dt>
<dd>Anzahl I-Ereignisse (nur ausfüllen, wenn keine automatische Verknüpfung geplant ist!) pro Untergruppe</dd>
<dt>Refusé</dt>
<dd>Anzahl Refusé-Ereignisse mit Typen X, U, T pro Untergruppe</dd>
<dt>Response</dt>
<dd>Anzahl R-Ereignisse pro Untergruppe</dd>
<dt>Resp. %</dt>
<dd>Response in Prozent: ( [Response] * 100 ) / [Initial] pro Untergruppe</dd>
<dt>Responsewert</dt>
<dd>Wert der R-Ereignisse pro Untergruppe</dd>
<dt>Wert</dt>
<dd>Response-Betrag pro Untergruppe</dd>
<dt>Resp./Adresse</dt>
<dd>Response pro Adresse = [Responsebetrag] / [Anzahl Responses]</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.ereignisse.html" title="Personenereignisse">Ereignisse</RouteLink>, <RouteLink to="/manual/customer/ereignisse-und-ereignispositionen.html" title="4. Ereignisse">Konzept Ereignisse</RouteLink></p>
</div></template>


